import React, {useState} from 'react';
import auth from "../../network/services/auth";
import otpRequestModel from "../../network/models/quick_models";

const LoginFormOTPVerification = ({change}) => {
    const [otp, setOtp] = useState('');

    const handleUserOtp = (event) => {
        setOtp(otp + event.target.value);
    };


    const loader = () => {
        change.callback({
            state: true,
            componentType: "loading",
            phone: change.current.phone,
            refId: change.current.refId
        });
    };

    const submitForm = () => {
        loader();

        let data = otpRequestModel.otpVerificationRequest;
        data.otp = otp;
        data.phone_number = change.current.phone;
        data.reference_id = change.current.refId;

        auth.verifyOtp(data).then(response => {
            change.callback({
                state: true,
                componentType: "password",
                phone: change.current.phone,
                refId: response.data.data.reference_id
            })

        }).catch(error => {
            change.callback({
                state: true,
                componentType: "verification",
                phone: change.current.phone,
                refId: ""
            })
        });
    };

    if (change.current.isActive) {
        submitForm()
    }

    return (
        <div className="row justify-content-center">
            <div className="col-md-5 col-lg-5 col-sm-5">
                <div className="text-left" style={{paddingLeft: 27, paddingRight: 27}}>
                    <ul className="list-unstyled">
                        <li>
                            <h6 className="header-text">
                                Please enter the 4-Digit code send to {change.current.phone}
                            </h6>
                        </li>
                        <li>
                            <p style={{fontSize: 10, lineHeight: 2}}>
                                You will receive an SMS for verification if you continue.
                                Normal SMS charges may apply.
                            </p>
                        </li>
                        <li style={{marginTop: 35}}>
                            <div className="row">
                                {
                                    [1, 2, 3, 4].map(i => {
                                        return (
                                            <div key={i} className="col-3">
                                                <div className="input-group">
                                                    <input type="text"
                                                           className="form-control form-control-lg input-form-alt"
                                                           placeholder=""
                                                           maxLength="1"
                                                           onChange={handleUserOtp}
                                                           aria-label="Username" aria-describedby="basic-addon1"/>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>);
};

export default LoginFormOTPVerification;
